"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebChatUpsellToast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_popup_1 = require("@snapchat/web-popup");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const react_intl_1 = require("react-intl");
const web_i18n_1 = require("@snapchat/web-i18n");
const messageLoader_1 = require("../../i18n/messageLoader");
const ToastBodyExpanded_1 = __importDefault(require("./ToastBodyExpanded"));
const MICROSOFT_APP_BLIZZARD_EVENT_DESTINATION = "windows_app_store";
/**
 * add this to the top of your page's component tree
 */
function WebChatUpsellToast({ disableQRCode, pageType, locale, webClientId, webPageViewTraceId, closeByDefault, }) {
    const [messages, setMessages] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        void (0, messageLoader_1.loadMessages)(locale).then((_messages) => {
            setMessages(_messages);
        });
    }, [locale]);
    const baseUpsellClickPayload = (0, react_1.useMemo)(() => ({
        pageType,
        actionName: web_blizzard_reporting_1.WebActionName.OpenWebChatCta,
        actionSource: web_blizzard_reporting_1.WebActionSource.UpsellToast,
        webClientId: webClientId ?? "",
    }), [pageType, webClientId]);
    const onUpsellClick = (0, react_1.useCallback)(() => {
        (0, web_blizzard_reporting_1.reportWebAction)(baseUpsellClickPayload);
    }, [baseUpsellClickPayload]);
    const onMicrosoftUpsellClick = (0, react_1.useCallback)(() => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            ...baseUpsellClickPayload,
            destination: MICROSOFT_APP_BLIZZARD_EVENT_DESTINATION,
        });
    }, [baseUpsellClickPayload]);
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsx)(web_popup_1.Popup, { children: (0, jsx_runtime_1.jsx)("div", { className: "desktopOnly", children: (0, jsx_runtime_1.jsx)(ToastBodyExpanded_1.default, { webClientId: webClientId, disableQRCode: disableQRCode, pageType: pageType, webPageViewTraceId: webPageViewTraceId, localeProps: locale, closeByDefault: closeByDefault, onUpsellClick: onUpsellClick, onMicrosoftUpsellClick: onMicrosoftUpsellClick }) }) }) }));
}
exports.WebChatUpsellToast = WebChatUpsellToast;
//# sourceMappingURL=index.js.map